// extracted by mini-css-extract-plugin
export default {"container":"YX-z","title":"ZX-z","link":"_X-z"};